import ListProcesses from "@/views/packing_house/production/final_packing_list_simplified/ListProcesses.vue";
import ShowProcess from "@/views/packing_house/production/final_packing_list_simplified/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/packing_house/production/final_packing_list_simplified/show_process/Containers.vue";
import ShowProcessPackagesFromStock from "@/components/views/packing_house/production/final_packing_list_simplified/show_process/PackagesFromStock.vue";
import ShowContainer from "@/views/packing_house/production/final_packing_list_simplified/ShowContainer.vue";
import AssignPackages from "@/views/packing_house/production/final_packing_list_simplified/AssignPackages.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ph",
  role: "production",
  permission: "final_packing_list_simplified",
});

export default [
  {
    path: "/ph/:packing_house_id/production/final_packing_list_simplified/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/production/final_packing_list_simplified/show_process/:packing_house_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_containers") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "containers",
        name: routeName("show_process_containers"),
        component: ShowProcessContainers,
        props: true,
        meta: META,
      },
      {
        path: "packages_from_stock",
        name: routeName("show_process_packages_from_stock"),
        component: ShowProcessPackagesFromStock,
        props: true,
        meta: META,
      },
    ],
  },
  {
    path: "/ph/:packing_house_id/production/final_packing_list_simplified/packing_house_process/:packing_house_process_id/container/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META,
  },
  {
    path: "/ph/:packing_house_id/production/final_packing_list_simplified/:packing_house_process_id/container/:container_id/assign_packages",
    name: routeName("assign_packages"),
    component: AssignPackages,
    props: true,
    meta: META,
  },
];
